import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentsService } from 'src/app/core/service/payments.service';
import { ToastAlertService } from 'src/app/shared/utils/toast.service';

@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss']
})
export class CouponComponent {
  @Input() coupons: any[] = [];
  @Input() appliedCoupon: any = null; 
  @Input() checkOutData:any;
  @Output() remove = new EventEmitter<void>();

   
  @Output() couponApplied = new EventEmitter<any>();
  couponCode: string = '';
  constructor(public activeModal: NgbActiveModal,private toastService:ToastAlertService,private paymentsService:PaymentsService) {
  }

  applyCoupon(coupon: any) {
    this.activeModal.close(coupon); 
  }

  close() {
    this.activeModal.dismiss(); 
  }

  applyCouponCode() {
    const enteredCode = this.couponCode.trim().toUpperCase();

    if (!enteredCode) { return; }
    let {moduleType,applicantId, moduleTypeId,moduleTypeSubId,paymentType,membershipid}=this.checkOutData
    let payLoad = {
      couponCode: enteredCode,
      moduleType: moduleType,
      moduleTypeId:moduleTypeId,
      moduleTypeSubId: moduleTypeSubId,
      userId: applicantId,
    }

    if (paymentType === 'membership') {
      payLoad['membershipTypeId']=membershipid ;
    }

    this.paymentsService.applyCoupon(paymentType,payLoad).subscribe({
      next: ({data}) => {
          this.appliedCoupon = data;
          this.couponApplied.emit(this.appliedCoupon);
      },
      error: (err) => {
        this.toastService.showToast(err.error.message, 'error');
      }
    });
  }
  
  onRemove(): void {
  this.couponCode = '';      
  this.remove.emit();     
}
}
